module.exports = __webpack_public_path__ + "static/studio-1-ae0150c08dbcc95e4f50458e02e5bd5c.jpg";